<template>
  <div class="w-full bg-GRIS_CLARO">
    <!-- BLOQUE INTRO -->
    <section class="overflow-hidden" style="background-image: url('/img/revisiontecnica/home/background_s8.png');">
      <div class="mx-auto grid max-w-[76rem] grid-cols-1 items-center gap-8 px-6 pt-10 md:grid-cols-[140px_minmax(0,1fr)_320px] md:px-8 md:pt-12">
        <div class="hidden md:flex items-center justify-center text-white/50">
          <svg class="h-[6rem] w-[6rem]" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="18" y="14" width="48" height="66" rx="6" stroke="currentColor" stroke-width="4"/>
            <path d="M34 14V10C34 7.79086 35.7909 6 38 6H46C48.2091 6 50 7.79086 50 10V14" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
            <path d="M31 33L36 38L45 28" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M31 52L36 57L45 47" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M53 31H65" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
            <path d="M53 50H65" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
            <rect x="31" y="64" width="10" height="10" rx="2" stroke="currentColor" stroke-width="4"/>
          </svg>
        </div>

        <div class="text-BLANCO_LEON">
          <p class="mx-auto max-w-[48rem] text-center text-[1rem] leading-8 md:text-left md:text-[1.05rem]">
            {{ REVISION_TECNICA_HOME.hero_texto }}
          </p>
        </div>

        <div class="flex justify-center md:justify-end">
          <img
            :src="REVISION_TECNICA_HOME.imagen_intro"
            alt="Mascota LEÓN revisión técnica"
            class="w-[15rem] max-w-full md:w-[520p]"
            loading="lazy"
          >
        </div>
      </div>
    </section>

    <!-- BLOQUE BENEFICIOS -->
    <section class="px-4 py-12 md:px-6 md:py-16">
      <div class="mx-auto max-w-[76rem]">
        <!-- Desktop -->
        <div class="hidden md:block">
          <div class="grid grid-cols-3 gap-6">
            <RevisionTecnicaBenefitCard
              v-for="beneficio in beneficios_superiores"
              :key="beneficio.id"
              :icono="beneficio.icono"
              :titulo="beneficio.titulo"
              :texto="beneficio.texto"
            />
          </div>

          <div class="mt-6 grid grid-cols-3 gap-6">
            <div class="flex items-center justify-center rounded-[1.75rem] bg-transparent p-6 md:p-8">
              <p class="text-center text-[1.03rem] leading-8 text-GRIS_LEON">
                <span class="font-extrabold text-ROJO_LEON">En LEÓN Servicio Automotriz,</span>
                {{ texto_editorial_sin_prefijo }}
              </p>
            </div>

            <RevisionTecnicaBenefitCard
              v-for="beneficio in beneficios_inferiores"
              :key="beneficio.id"
              :icono="beneficio.icono"
              :titulo="beneficio.titulo"
              :texto="beneficio.texto"
            />
          </div>
        </div>

        <!-- Mobile -->
        <div class="md:hidden">
          <div class="mx-auto max-w-[21rem]">
            <Carrusel
              :data="REVISION_TECNICA_BENEFICIOS"
              :itemsPorPagina="1"
              ClaseSlide="flex h-full"
              :autoplay="true"
              :autoplayInterval="4500"
              :bucle="true"
              :habilitarBotonesNav="false"
              :motrarPuntos="true"
              PadreDotClass="mt-5"
              customDotClass="h-[0.65rem] w-[0.65rem]"
              customActiveDotClass="bg-ROJO_LEON"
              customInactiveDotClass="bg-[#CFCFCF]"
              wrapperClass="overflow-hidden"
              slideClass="w-full"
            >
              <template #contenido="{ items }">
                <div class="w-full px-1" v-for="beneficio in items" :key="beneficio.id">
                  <RevisionTecnicaBenefitCard
                    :icono="beneficio.icono"
                    :titulo="beneficio.titulo"
                    :texto="beneficio.texto"
                    custom_class="min-h-[23rem]"
                  />
                </div>
              </template>
            </Carrusel>
          </div>

          <div class="mx-auto mt-8 max-w-[22rem] px-2">
            <p class="text-center text-[1rem] leading-8 text-GRIS_LEON">
              <span class="font-extrabold text-ROJO_LEON">En LEÓN Servicio Automotriz,</span>
              {{ texto_editorial_sin_prefijo }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- BLOQUE PRECIO -->
    <section class="overflow-hidden" style="background-image: url('/img/revisiontecnica/home/background_s8.png');">
      <div class="mx-auto grid max-w-[76rem] grid-cols-1 gap-8 px-6 py-12 md:grid-cols-[minmax(0,1fr)_320px] md:px-8 md:py-14">
        <div class="text-BLANCO_LEON">
          <h2 class="text-[2rem] font-extrabold leading-[1.1] md:text-[2.3rem]">
            {{ REVISION_TECNICA_HOME.precio_titulo }}
          </h2>

          <div class="mt-5 flex flex-col gap-4 text-[0.97rem] leading-8 text-BLANCO_LEON/95 md:text-[1rem]">
            <p>{{ REVISION_TECNICA_HOME.precio_detalle_1 }}</p>
            <p>{{ REVISION_TECNICA_HOME.precio_detalle_2 }}</p>
          </div>

          <button
            type="button"
            class="mt-7 inline-flex items-center justify-center rounded-xl bg-ROJO_LEON px-6 py-3 text-[0.98rem] font-extrabold text-BLANCO_LEON transition hover:opacity-90"
            @click="ir_al_inicio_layout"
          >
            Agendar visita
          </button>
        </div>

        <div class="flex items-end justify-center md:justify-end">
          <img
            :src="REVISION_TECNICA_HOME.imagen_precio"
            alt="Mascota LEÓN agendar revisión técnica"
            class="w-[16rem] max-w-full md:w-[300px]"
            loading="lazy"
          >
        </div>
      </div>
    </section>

    <!-- FRANJA ROJA -->
    <section
      class="overflow-hidden"
      style="background-image: url('/img/revisiontecnica/home/background_s6_nueva.png');"
    >
      <div class="mx-auto grid max-w-[76rem] grid-cols-1 items-center gap-8 px-6 pt-10 md:grid-cols-[260px_minmax(0,1fr)_120px] md:px-8 md:pt-12">
        <div class="flex justify-center md:justify-start">
          <img
            :src="REVISION_TECNICA_HOME.imagen_tecnicos"
            alt="Equipo LEÓN revisión técnica"
            class="w-[13rem] max-w-full md:w-[320px]"
            loading="lazy"
          >
        </div>

        <div>
          <p class="text-center text-[1rem] leading-8 text-BLANCO_LEON md:text-left md:text-[1.05rem]">
            {{ REVISION_TECNICA_HOME.requisitos_intro }}
          </p>
        </div>

        <div class="hidden md:flex items-center justify-end text-BLANCO_LEON/20">
          <svg class="h-[5rem] w-[5rem]" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M56.6 10L59.7 19.9C62 20.6 64.1 21.5 66.1 22.7L75.7 18L82 24.3L77.3 33.9C78.5 35.9 79.4 38 80.1 40.3L90 43.4V52.6L80.1 55.7C79.4 58 78.5 60.1 77.3 62.1L82 71.7L75.7 78L66.1 73.3C64.1 74.5 62 75.4 59.7 76.1L56.6 86H47.4L44.3 76.1C42 75.4 39.9 74.5 37.9 73.3L28.3 78L22 71.7L26.7 62.1C25.5 60.1 24.6 58 23.9 55.7L14 52.6V43.4L23.9 40.3C24.6 38 25.5 35.9 26.7 33.9L22 24.3L28.3 18L37.9 22.7C39.9 21.5 42 20.6 44.3 19.9L47.4 10H56.6Z" stroke="currentColor" stroke-width="4"/>
            <circle cx="52" cy="48" r="14" stroke="currentColor" stroke-width="4"/>
          </svg>
        </div>
      </div>
    </section>

    <!-- REQUISITOS -->
    <section class="px-4 py-12 md:px-6 md:py-16">
      <div class="mx-auto max-w-[76rem]">
        <!-- Desktop -->
        <div class="hidden md:grid md:grid-cols-3 md:gap-6">
          <RevisionTecnicaRequirementCard
            v-for="item in REVISION_TECNICA_REQUISITOS"
            :key="item.id"
            :imagen="item.imagen"
            :titulo="item.titulo"
            :texto="item.texto"
          />
        </div>

        <!-- Mobile -->
        <div class="md:hidden">
          <div class="mx-auto max-w-[21rem]">
            <Carrusel
              :data="REVISION_TECNICA_REQUISITOS"
              :itemsPorPagina="1"
              ClaseSlide="flex h-full"
              :autoplay="true"
              :autoplayInterval="4500"
              :bucle="true"
              :habilitarBotonesNav="false"
              :motrarPuntos="true"
              PadreDotClass="mt-5"
              customDotClass="h-[0.65rem] w-[0.65rem]"
              customActiveDotClass="bg-ROJO_LEON"
              customInactiveDotClass="bg-[#CFCFCF]"
              wrapperClass="overflow-hidden"
              slideClass="w-full"
            >
              <template #contenido="{ items }">
                <div class="w-full px-1" v-for="item in items" :key="item.id">
                  <RevisionTecnicaRequirementCard
                    :imagen="item.imagen"
                    :titulo="item.titulo"
                    :texto="item.texto"
                  />
                </div>
              </template>
            </Carrusel>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Carrusel from '~/components/Carruseles/Carrusel.vue'
import RevisionTecnicaBenefitCard from '~/components/RevisionTecnica/RevisionTecnicaBenefitCard.vue'
import RevisionTecnicaRequirementCard from '~/components/RevisionTecnica/RevisionTecnicaRequirementCard.vue'
import {
  REVISION_TECNICA_HOME,
  REVISION_TECNICA_BENEFICIOS,
  REVISION_TECNICA_REQUISITOS,
} from '~/constants/revisiontecnica-home'

const beneficios_superiores = computed(() => REVISION_TECNICA_BENEFICIOS.slice(0, 3))
const beneficios_inferiores = computed(() => REVISION_TECNICA_BENEFICIOS.slice(3))

const texto_editorial_sin_prefijo = computed(() =>
  REVISION_TECNICA_HOME.editorial_beneficios.replace('En LEÓN Servicio Automotriz, ', '')
)

const ir_al_inicio_layout = () => {
  if (typeof window === 'undefined') return

  const layout = document.querySelector('.layout_principal')

  if (layout) {
    layout.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    return
  }

  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
</script>

<style scoped>
.bg-patron-negro {
  background-color: #0a0a0a;
  background-image:
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.06) 0 2px, transparent 2px),
    radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.05) 0 2px, transparent 2px),
    linear-gradient(90deg, rgba(0, 0, 0, 0.96) 0%, rgba(22, 22, 22, 0.93) 48%, rgba(0, 0, 0, 0.98) 100%);
  background-size: 26px 26px, 26px 26px, 100% 100%;
  background-position: 0 0, 13px 13px, center;
}

.bg-patron-rojo {
  background-color: #cf2020;
  background-image:
    radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.07) 0 2px, transparent 2px),
    radial-gradient(circle at 75% 65%, rgba(255, 255, 255, 0.05) 0 2px, transparent 2px),
    linear-gradient(90deg, rgba(190, 25, 25, 0.95) 0%, rgba(209, 31, 31, 0.97) 50%, rgba(190, 25, 25, 0.95) 100%);
  background-size: 26px 26px, 26px 26px, 100% 100%;
  background-position: 0 0, 13px 13px, center;
}
</style>